import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

export const AuroraBackground = () => {
  const { scrollYProgress } = useScroll();
  
  // Orb 1 moves down and right
  const orb1Y = useTransform(scrollYProgress, [0, 1], ['0%', '100%']);
  const orb1X = useTransform(scrollYProgress, [0, 1], ['0%', '50%']);
  
  // Orb 2 moves up and left
  const orb2Y = useTransform(scrollYProgress, [0, 1], ['0%', '-50%']);
  const orb2X = useTransform(scrollYProgress, [0, 1], ['0%', '-100%']);
  
  // Orb 3 moves horizontally
  const orb3X = useTransform(scrollYProgress, [0, 1], ['0%', '200%']);

  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
      {/* Base Grid */}
      <div 
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: "linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)",
          backgroundSize: '50px 50px'
        }}
      />

      {/* Aurora Orbs */}
      <motion.div 
        className="absolute top-[-10%] left-[10%] w-[800px] h-[800px] rounded-full blur-[120px] opacity-10"
        style={{ 
          background: 'radial-gradient(circle, rgba(11,217,229,0.8), transparent 70%)',
          y: orb1Y,
          x: orb1X
        }}
      />
      
      <motion.div 
        className="absolute top-[40%] right-[5%] w-[700px] h-[600px] rounded-full blur-[100px] opacity-10"
        style={{ 
          background: 'radial-gradient(circle, rgba(168,85,247,0.6), transparent 70%)',
          y: orb2Y,
          x: orb2X
        }}
      />

      <motion.div 
        className="absolute bottom-[-20%] left-[20%] w-[1000px] h-[1000px] rounded-full blur-[150px] opacity-[0.07]"
        style={{ 
          background: 'radial-gradient(circle, rgba(6,182,212,0.8), transparent 70%)',
          x: orb3X
        }}
      />
    </div>
  );
};

export default AuroraBackground;
